module.exports = __webpack_public_path__ + "img/christmas-crew-2026.9c4b0c2c.png";